<template>
  <tr>
    <td class="text-xs-center px-0" style="padding-right: 0px; padding-left: 0px; width: 0">
        <v-tooltip :color="props.item.pendente ? 'warning' : ( props.item.consolidada ? 'success' : 'error')" top>
          <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-icon :color="props.item.pendente ? 'warning' : ( props.item.consolidada ? 'success' : 'error')">{{ props.item.pendente ? 'access_alarms' : (props.item.consolidada ? 'check_circle' : 'error')}} </v-icon>
              </span>
          </template>
          <span>Consolidado</span>
      </v-tooltip>
    </td>
    <td class="px-0"><strong>{{ props.item.numero }}</strong></td>
    <td class="text-xs-left px-3" style="width: auto">
      {{`${props.item.cliente.nome} ${props.item.cliente.sobrenome}` | truncate(30) }}
      <div><strong>{{props.item.cliente.cpf}}</strong></div>
    </td>
    <td class="text-xs-left px-3">
      <strong>{{ props.item.codigo_cupom || "INDEFINIDO" }}</strong>
    </td>
    <td class="text-xs-right  px-0">{{ props.item.quantidade_litros }} {{props.item.combustivel.descricao_volume}}</td>
    <td class="justify-center layout px-0" style="padding-right: 0px; padding-left: 0px;">
      <v-tooltip v-if="props.item.combustivel" :color="props.item.combustivel.color" top>
          <template v-slot:activator="{ on }">
              <span v-on="on">
                  <svg-filler :path="require(`@/assets/combs/${props.item.combustivel.icone}.svg`)" width="40px" height="40px" :fill="'grey'"/>
              </span>
          </template>
          <span>{{props.item.combustivel.nome}}</span>
      </v-tooltip>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['props'],
  mounted () {
    this.$root.$on('saveDataConsolidacaoAbastecimento', () => {
      if (this.props.item.pendente) {
        this.$store.dispatch('saveDataConsolidacaoAbastecimento', {
          id_voucher: this.props.item.id_voucher,
          motorista: this.props.item.motorista,
          quilometragem: this.props.item.quilometragem
        }).then(() => {
          let item = { ...this.props.item, motorista: this.props.item.motorista, quilometragem: this.props.item.quilometragem, consolidada: true, pendente: false }
          this.$emit('setItem', { element: item, index: this.props.index })
        })
      }
      // if (this.props.item.pendente) {
      //   let item = { ...this.props.item, num_cartao: this.props.item.cartao.numero, nsu: this.props.item.nsu, consolidada: true, pendente: false }
      //   this.$emit('setItem', { element: item, index: this.props.index })
      // }
    })
  }
}
</script>
